module.exports = __webpack_public_path__ + "static/carson_s-51b4cc1ac9d74368560018c603774dd1.png";